import { routes } from "@libs/routing/routes.ts";
import { NavLink } from "@ui-components/navigation/Nav.tsx";

export const useNewPaymentLink = (): NavLink => ({
  name: "New payment",
  path: routes.accounts.allocations.new,
  showBorder: true
});
